import { render, staticRenderFns } from "./login_phone.vue?vue&type=template&id=1ec3a294&scoped=true"
import script from "./login_phone.vue?vue&type=script&lang=js"
export * from "./login_phone.vue?vue&type=script&lang=js"
import style0 from "./login_phone.vue?vue&type=style&index=0&id=1ec3a294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3a294",
  null
  
)

export default component.exports